import React, { Fragment } from 'react';
import {
  List,
  Edit,
  Create,
  Datagrid,
  FunctionField,
  BooleanField,
  NumberField,
  EditButton,
  DisabledInput,
  TextField,
  TabbedForm,
  FormTab,
  SelectInput,
  BooleanInput,
  TextInput,
  LongTextInput,
  ReferenceInput,
  ArrayInput,
  CheckboxGroupInput,
  SimpleFormIterator,
  CardActions,
  Toolbar,
  SaveButton,
  ListButton,
  Filter,
  GET_LIST
} from 'react-admin';

import Button from '@material-ui/core/Button';
import CheckBox from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlank from '@material-ui/icons/CheckBoxOutlineBlank';

import BulkUpdateButton from './ui/BulkUpdateButton';
import SortableIterator from './ui/SortableIterator';
import CrawledArticlesDialog from './ui/CrawledArticlesDialog';
import LoadCategoriesField from './ui/LoadCategoriesField';

import tags from '../config/tags';
import { categories_types, site_weights } from '../config/site_config';

import restClient from '../services/restClient';
import { appOptions } from '../config/app';

const MediasourceBulkActionButtons = props => (
  <Fragment>
      <BulkUpdateButton {...props} field='active' value={true} label='Activate' icon={<CheckBox />} color='primary' />
      <BulkUpdateButton {...props} field='active' value={false} label='Deactivate' icon={<CheckBoxOutlineBlank />} color='secondary' />
      <BulkUpdateButton {...props} field='crawlable' value={true} label='Enable crawl' icon={<CheckBox />} color='primary' />
      <BulkUpdateButton {...props} field='crawlable' value={false} label='Disable crawl' icon={<CheckBoxOutlineBlank />} color='secondary' />
  </Fragment>
);

const ListFilter = props => (
  <Filter {...props}>
    <TextInput label="Search" source="q" alwaysOn />
    <BooleanInput label="Active" source="active" />
    <BooleanInput label="Crawlable" source="crawlable" />
    <BooleanInput label="Active statistika" source="active_statistika" />
  </Filter>
);

const MediasourceToolbar = props => (
  <Toolbar {...props} >
      <SaveButton />
  </Toolbar>
);

export const MediasourceList = props => (
  <List title="Media Sources" {...props} bulkActionButtons={<MediasourceBulkActionButtons />} filters={<ListFilter />} sort={{ field: 'name', order: 'asc' }} perPage={1000}>
    <Datagrid>
      <TextField source="id" sortable={false} />
      <FunctionField
        source="name"
        label="Name"
        render={record => (
          <a href={record.domain} target="_blank" rel="noopener noreferrer">
            {record.name}
          </a>
        )}
      />
      <NumberField source="weight" />
      <BooleanField source="active" />
      <BooleanField source="crawlable" />
      <BooleanField source="active_statistika" />
      <BooleanField source="active_info" />
      <BooleanField source="active_fb" />
      <EditButton label="" />
    </Datagrid>
  </List>
);

const SiteName = ({ record }) => {
  return <span>Site {record ? `"${record.id}"` : ''}</span>;
};

export class MediasourceEdit extends React.Component {
  state = {
    categories: [],
    crawlertypes: [],
  };

  componentDidMount() {
    const apiClient = restClient(appOptions);
    apiClient(GET_LIST, 'articles/categories-choice').then(res => {
      this.setState({ categories: res.data});
    });
    apiClient(GET_LIST, 'mediaSources/crawlertypes').then(res => {
      this.setState({ crawlertypes: res.data});
    });
  }

  render () {
    const MediasourceEditActions = ({ basePath, data, resource }) => (
      <CardActions>
          <ListButton basePath={basePath} variant="outlined" style={{marginRight: '10px', padding: '7px 16px'}} />
          <Button style={{marginRight: '10px'}} variant="outlined" color="primary" href={data && '/#/articles/report/' + data.id}>Report</Button>
          <CrawledArticlesDialog />
      </CardActions>
    );
    

    return (
    <Edit title={<SiteName />} actions={<MediasourceEditActions />} {...this.props}>
      <TabbedForm toolbar={<MediasourceToolbar />}>
        <FormTab label="Details">
          <DisabledInput source="id" />
          <TextInput source="domain" />
          <TextInput source="name" />
          <SelectInput source="type" choices={this.state.crawlertypes} />
          <ReferenceInput label="Media Type" source={`source_type`} reference="mediasources/types" allowEmpty>
            <SelectInput source="name" />
          </ReferenceInput>
          <SelectInput source="weight" choices={site_weights} />
          <BooleanInput label="Active" source="active" />
          <BooleanInput label="Active (Statistika)" source="active_statistika" />
          <BooleanInput label="Active (fb popular)" source="active_fb" />
          <BooleanInput label="Crawlable" source="crawlable" />
        </FormTab>
        <FormTab label={`Start URLs`}>
          <ArrayInput source={`start_urls`} className="inline-form">
            <SimpleFormIterator>
              <TextInput label="Url" source="url" />
              <TextInput label="Category" source="category" />
              <BooleanInput label="Cached" source="cached" />
            </SimpleFormIterator>
          </ArrayInput>
        </FormTab>
        <FormTab label={`Categories mapping`}>
          <LoadCategoriesField />
          <ArrayInput source={`categories`} className="inline-form" label="">
            <SortableIterator keyName="name">
              <TextInput label="Source Category" source="name" />
              <SelectInput label="Target Category" source="ref" choices={this.state.categories} />
              <SelectInput label="Type" source="type" choices={categories_types} />
            </SortableIterator>
          </ArrayInput>
        </FormTab>
        <FormTab label={`XPath settings`}>
          <LongTextInput label="XPath - Articles list" source="xpaths.articles" />
          <LongTextInput label="XPath - Title" source="xpaths.title" />
          <LongTextInput label="XPath - Link" source="xpaths.link" />
          <LongTextInput label="XPath - Content" source="xpaths.content" />
          <LongTextInput label="XPath - Description" source="xpaths.description" />
          <LongTextInput label="XPath - Pictures" source="xpaths.pictures" />
          <LongTextInput label="XPath - Thumbnail" source="xpaths.thumbnail" />
          <LongTextInput label="XPath - Categories" source="xpaths.categories" />
          <LongTextInput label="XPath - Html" source="xpaths.html" />
        </FormTab>
        
        <FormTab label={`Additional settings`}>
          <TextInput label="Facebook id" source={`page_id`} />
          <SelectInput
            source={`tag.ref`}
            label="Polarity"
            allowEmpty={true}
            choices={tags}
            optionValue="ref"
          />
          <BooleanInput label="Cloudflare" source="cloudflare" />
          <BooleanInput label="Transliterate" source="transliterate" />
        </FormTab>

        <FormTab label={`Info.mk`}>
          <BooleanInput label="Active (info.mk)" source="active_info" defaultValue={false} />
          <CheckboxGroupInput source="info_categories" choices={this.state.categories.filter(x => x.id != "ignore" && !x.hide)} defaultValue={this.state.categories.filter(x => x.id != "ignore" && !x.hide).map(x => x.id)} />
        </FormTab>
      </TabbedForm>
    </Edit>
    )
  }
};

export class MediasourceCreate extends React.Component {
  state = {
    categories: [],
    crawlertypes: [],
  };

  componentDidMount() {
    const apiClient = restClient(appOptions);
    apiClient(GET_LIST, 'articles/categories-choice').then(res => {
      this.setState({ categories: res.data});
    });
    apiClient(GET_LIST, 'mediaSources/crawlertypes').then(res => {
      this.setState({ crawlertypes: res.data});
    });
  }

  render () {
    const MediasourceCreateActions = ({ basePath, data, resource }) => (
      <CardActions>
          <ListButton basePath={basePath} variant="outlined" style={{marginRight: '10px', padding: '7px 16px'}} />
          <CrawledArticlesDialog />
      </CardActions>
    );

    return (
    <Create title={<SiteName />} actions={<MediasourceCreateActions />} {...this.props}>
      <TabbedForm>
        <FormTab label="Details">
          <TextInput source="id" />
          <TextInput source="domain" />
          <TextInput source="name" />
          <SelectInput source="type" choices={this.state.crawlertypes} />
          <ReferenceInput label="Media Type" source={`source_type`} reference="mediasources/types" allowEmpty>
            <SelectInput source="name" />
          </ReferenceInput>
          <SelectInput source="weight" choices={site_weights} />
          <BooleanInput label="Active" source="active" />
          <BooleanInput label="Active (Statistika)" source="active_statistika" />
          <BooleanInput label="Active (fb popular)" source="active_fb" />
          <BooleanInput label="Crawlable" source="crawlable" />
        </FormTab>
        <FormTab label={`Start URLs`}>
          <ArrayInput source={`start_urls`} className="inline-form">
            <SimpleFormIterator>
              <TextInput label="Url" source="url" />
              <TextInput label="Category" source="category" />
              <BooleanInput label="Cached" source="cached" />
            </SimpleFormIterator>
          </ArrayInput>
        </FormTab>
        <FormTab label={`Categories mapping`}>
          <LoadCategoriesField />
          <ArrayInput source={`categories`} className="inline-form" label="">
            <SortableIterator keyName="name">
              <TextInput label="Source Category" source="name" />
              <SelectInput label="Target Category" source="ref" choices={this.state.categories} />
              <SelectInput label="Type" source="type" choices={categories_types} />
            </SortableIterator>
          </ArrayInput>
        </FormTab>
        <FormTab label={`XPath settings`}>
          <LongTextInput label="XPath - Articles list" source="xpaths.articles" />
          <LongTextInput label="XPath - Title" source="xpaths.title" />
          <LongTextInput label="XPath - Link" source="xpaths.link" />
          <LongTextInput label="XPath - Content" source="xpaths.content" />
          <LongTextInput label="XPath - Description" source="xpaths.description" />
          <LongTextInput label="XPath - Pictures" source="xpaths.pictures" />
          <LongTextInput label="XPath - Thumbnail" source="xpaths.thumbnail" />
          <LongTextInput label="XPath - Categories" source="xpaths.categories" />
        </FormTab>
        
        <FormTab label={`Additional settings`}>
          <TextInput label="Facebook id" source={`page_id`} />
          <SelectInput
            source={`tag.ref`}
            label="Polarity"
            allowEmpty={true}
            choices={tags}
            optionValue="ref"
          />
          <BooleanInput label="Cloudflare" source="cloudflare" />
          <BooleanInput label="Transliterate" source="transliterate" />
        </FormTab>
      </TabbedForm>
    </Create>
    )
  }
};


// WEBPACK FOOTER //
// ./src/resources/mediasources.js